goog.provide('el8.tourguide.Guide');

goog.require('el8.app.pageLayout');
goog.require('el8.tourguide.Visor');

/**
 * This widget manages all of the slides involves with Explore (tourguide)
 */
el8.tourguide.Guide = function(opts) {
    this._opts = opts || {};
    this._visor = null;
    this._visorOpts = opts.visorOpts || null;
    this._isMinimized = null;
    this._slides = [];
    this._slideNameToIndex = {};
    this._currentSlideIndex = null;
    this._navTemplateFn = this._opts.navTemplateFn;
    this._detailTemplateFn = this._opts.detailTemplateFn;
    this._hasSplashPage = (this._opts.hasSplashPage === true);
    this._splashStartFn = this._opts.splashStartFn || null;
    this._splashStartBtnFn = this._opts.splashStartBtnFn || function() { return 'Start'; };
    this._startFn = this._opts.startFn || null;
    this._enterFn = this._opts.enterFn || null;
    this._endFn = this._opts.endFn || null;
    this._inProgress = false;

    // Want to have the visor set up right away
    if (this._visorOpts) {
        this._visor = new el8.tourguide.Visor(this._visorOpts);
        if (this._navTemplateFn) {
            this._visor.updateNavContent(this._navTemplateFn);
        }
        if (this._detailTemplateFn) {
            this._visor.updateDetailContent(this._detailTemplateFn);
        }
        this._visor.show(true);
        this._container = this._visor.getContainer();
    }
};

el8.tourguide.Guide.prototype.init = function() {

    if (this._isInit) { return; }
    this._isInit = true;
    var that = this;

    if (this._hasSplashPage) {
        this._splash = $('#tourguide-splash');

        $('.start-trigger', this._splash)
            .removeClass('imageLoading')
            .html(this._splashStartBtnFn());  // XSS OK -KF

        this._splash.on('click', '.start-trigger', function(e) {
            if (that._splashStartFn) {
                that._splashStartFn();
                if (that._splash) { that._splash.remove(); }
            } else {
                that.start();
            }
        });
    }

    if (this._visor) { this._visor.initFocus(); }

};

el8.tourguide.Guide.prototype.addSlide = function(slide) {
    this._slides.push(slide);
    this._slideNameToIndex[slide.getName()] = this._slides.length - 1;
    if (this._visor && slide.getNavCaption()) {
        this._visor.addSlideNav(slide);
    }
};

el8.tourguide.Guide.prototype.start = function() {
    if (this._inProgress) {
        this.jumpTo(0);
        return;
    }
    this._inProgress = true;
    if (this._splash) { this._splash.remove(); }
    if (!this._isInit) { this.init(); }
    if (this._startFn) { this._startFn(); }

    this.enter();

    return this;
};

el8.tourguide.Guide.prototype.enter = function() {
    if (this._enterFn) { this._enterFn(); }
    if (!this._resizeFn) {
        var that = this;
        this._resizeFn = function() {
            var currentSlide = that.getCurrentSlide();
            if (currentSlide) {
                that.refreshSlide(currentSlide);
            }
        };
    }
    el8.app.pageLayout.addResizeListener(this._resizeFn);
};

el8.tourguide.Guide.prototype.next = function() {
    var nextSlideIndex = this.getNextSlideIndex();
    if (nextSlideIndex !== null) {
        this.jumpTo(nextSlideIndex);
    } else {
        this.end();
    }
};

el8.tourguide.Guide.prototype.previous = function() {
    var previousSlideIndex = this.getPreviousSlideIndex();
    if (previousSlideIndex !== null) {
        this.jumpTo(previousSlideIndex);
    }
};

el8.tourguide.Guide.prototype.jumpTo = function(slideIndex) {
    var currentSlide = this.getCurrentSlide();
    if (currentSlide) { this.hideSlide(currentSlide); }
    var newSlide = this._slides[slideIndex];
    this.showSlide(newSlide);
};

el8.tourguide.Guide.prototype.jumpToName = function(name, doQuick) {
    var currentSlide = this.getCurrentSlide();
    if (currentSlide) { this.hideSlide(currentSlide); }
    var newSlideInfo = this.getSlideInfoByName(name);
    var newSlide = newSlideInfo.slide;
    this.showSlide(newSlide, doQuick);
};

el8.tourguide.Guide.prototype.hideSlideByName = function(name) {
    var slideInfo = this.getSlideInfoByName(name);
    if (slideInfo && slideInfo.slide) { this.hideSlide(slideInfo.slide); }
};

el8.tourguide.Guide.prototype.end = function() {
    if (!this._inProgress) { return; }
    this._inProgress = false;
    var currentSlide = this.getCurrentSlide();
    if (currentSlide) { this.hideSlide(currentSlide); }
    if (this._endFn) { this._endFn(); }
    if (this._visor) { this._visor.clearFocus(); }
    el8.app.pageLayout.removeResizeListener(this._resizeFn);
};

el8.tourguide.Guide.prototype.getCurrentSlide = function() {
    if (this._currentSlideIndex !== null) {
        return this._slides[this._currentSlideIndex];
    }
    return null;
};

el8.tourguide.Guide.prototype.numSlides = function() {
    return this._slides.length;
};

el8.tourguide.Guide.prototype.showSlide = function(slide, doQuick) {
    this._inProgress = true;
    if (this._visor) {
        this._visor.hideDetail();
        if (slide.getNavTemplateFn()) {
            this._visor.updateNavContent(slide.getNavTemplateFn());
        }
        this._visor.focusSlide(slide);
    }
    slide.show(doQuick);
    this._currentSlideIndex = this._slideNameToIndex[slide.getName()];
    if (slide.getEventToSlideNameMap()) {
        var that = this;
        var map = slide.getEventToSlideNameMap();
        var genFn = function(_name) {
            return function() {
                if (_name) {
                    that.jumpToName(_name);
                } else {
                    that.next();
                }
            };
        };
        if (!el8.util.isEmptyObj(map)) {
            for (var ev in map) {
                if (map.hasOwnProperty(ev)) {
                    var name = map[ev];
                    $(document).on(ev, genFn(name));
                }
            }
        }
    }
};

el8.tourguide.Guide.prototype.hideSlide = function(slide) {
    slide.hide();
    this._currentSlideIndex = null;
    if (slide.getEventToSlideNameMap()) {
        var map = slide.getEventToSlideNameMap();
        for (var ev in map) {
            if (map.hasOwnProperty(ev)) {
                $(document).unbind(ev);
            }
        }
    }
};

el8.tourguide.Guide.prototype.refreshSlide = function(slide) {
    if (slide.getRefreshFn()) {
        slide.getRefreshFn()();
    } else {
        this.hideSlide(slide);
        this.showSlide(slide, true);
    }
};

el8.tourguide.Guide.prototype.getNextSlideIndex = function() {
    var nextSlideIndex = this._currentSlideIndex + 1;
    if (nextSlideIndex < this.numSlides()) {
        return nextSlideIndex;
    } else {
        return null;
    }
};

el8.tourguide.Guide.prototype.getPreviousSlideIndex = function() {
    if (this._currentSlideIndex <= 0) {
        return null;
    } else {
        return this._currentSlideIndex - 1;
    }
};

el8.tourguide.Guide.prototype.getSlideInfoByName = function(name) {
    for (var i=0; i<this._slides.length; i++) {
        var slide = this._slides[i];
        if (slide.getName() === name) {
            return {
                slide: slide,
                index: i
            };
        }
    }
    return null;
};

el8.tourguide.Guide.prototype.isCurrentSlide = function(name) {
    var currentSlide = this.getCurrentSlide();
    if (currentSlide) { return currentSlide.getName() === name; }
    return false;
};

el8.tourguide.Guide.prototype.isInProgress = function() {
    return !!this._inProgress;
};

el8.tourguide.Guide.prototype.getVisorElt = function() {
    return this._visor ? this._visor.getContainer() : null;
};
